/**
 * @Description 地图底色配置项
 */

import { FC } from 'react';
// import cs from 'classnames';
import styles from '../index.module.less';
import IconFont from '@/common/components/IconFont';
import { setStorage } from '@lhb/cache';

interface MapBGRadioProps {
  label: string;
  value: string;
  active: string;
  setActive: any;
  [p:string]: any;
}
const MapBGRadio: FC<MapBGRadioProps> = ({
  label,
  value,
  active,
  setActive,
}) => {
  return (
    <div className={styles.mapBGConfigItemCon} onClick={(e) => {
      setActive((state) => ({ ...state, bg: value }));
      setStorage('MAP_BG_CONFIG', value);
      e.stopPropagation();
    }}>
      <IconFont
        iconHref={active === value ? 'icondanxuanxuanzhong' : 'icondanxuan'}
        className='fs-13'
      />
      <div className='ml-4 fs-13 c-222'>
        {label}
      </div>
    </div>
  );
};

export default MapBGRadio;
